export const vi: Record<string, string> = {
  // Header
  'app.title': 'Xướng Lô Tô',
  'header.settings': 'Cài đặt',

  // Controls
  'controls.nextNumber': 'Số Tiếp Theo',
  'controls.startGame': 'Bắt Đầu Thôi!',
  'controls.autoPlay': 'Tự Động Phát',
  'controls.reset': 'Chơi ván mới',
  'controls.nextIn': 'Xướng số mới sau: {seconds}s',
  'controls.previous': 'Trước đó',

  // Display
  'display.ready': 'Sẵn Sàng Chưa?',
  'display.playing': '🔊 Đang xướng...',
  'display.skipAudio': 'Xướng lâu quá, bỏ qua!',

  // Settings modal
  'settings.title': 'Cài Đặt',
  'settings.language': 'Ngôn Ngữ của nhạc xướng',
  'settings.style': 'Phong Cách',
  'settings.range': 'Phạm Vi Số',
  'settings.min': 'Tối thiểu',
  'settings.max': 'Tối đa',
  'settings.interval': 'Khoảng cách (giây)',
  'settings.apply': 'Áp Dụng',
  'settings.cancel': 'Hủy',
  'settings.uiLanguage': 'Ngôn Ngữ Giao Diện',
  'settings.preview': 'Nghe thử',
  'settings.rangeLocked': 'Không thể thay đổi phạm vi trong trò chơi. Chơi ván mới để điều chỉnh.',
  'settings.hotSwitchWarning': '⚠️ Thay đổi phong cách giữa trò chơi chỉ ảnh hưởng số tiếp theo',

  // Modals
  'reset.title': '⚠️ Chơi Ván Mới?',
  'reset.message': 'Toàn bộ tiến trình sẽ bị mất. Đồng ý?',
  'reset.confirm': 'Chơi Ván Mới',
  'complete.title': '🎉 Đã Xướng Hết Tất Cả Các Số!',
  'complete.numbersCalled': 'Số đã xướng: {count}',
  'complete.timeElapsed': 'Thời gian: {time}',
  'complete.style': 'Phong cách: {style}',
  'complete.viewHistory': 'Xem Lịch Sử',
  'complete.newGame': 'Trò Chơi Mới',
  'history.title': '📜 Lịch Sử Gọi Số',
  'history.exportCsv': 'Xuất CSV',
  'history.close': 'Đóng',
  'history.order': 'Thứ tự',
  'history.number': 'Số đã xướng',

  // Status
  'status.called': 'Đã xướng: {called}/{total}',
  'status.time': 'Thời gian: {time}',

  // Toasts
  'toast.settingsSaved': 'Đã lưu cài đặt',
  'toast.styleChanged': 'Đã đổi phong cách. Số tiếp theo sẽ dùng phong cách mới.',
  'toast.audioUnavailable': 'Âm thanh không khả dụng cho số {number}',
  'toast.autoPlayPaused': 'Tự động xướng đã tạm dừng',
  'toast.autoPlayResumed': 'Tự động xướng đã tiếp tục',
  'toast.audioBlocked': '🔇 Âm thanh bị trình duyệt chặn. Nhấp để bật.',
  'toast.connectionLost': '⚠️ Mất kết nối mạng. Âm thanh có thể không tải được.',
  'toast.connectionRestored': 'Đã khôi phục kết nối',
  'toast.storageLimitReached': '⚠️ Đã đạt giới hạn lưu trữ',
  'toast.corruptedData': 'Dữ liệu phiên trước bị hỏng. Bắt đầu mới.',
  'toast.pleaseWait': '⏳ Vui lòng chờ âm thanh phát xong',
  'toast.previewNotAvailable': 'Không có bản xem trước cho phong cách này',
  'toast.previewFailed': 'Không thể phát bản xem trước',
  'toast.previewPlaying': '🔊 Đang phát bản xem trước...',

  // Emergency
  'emergency.title': '⚠️ Đang chạy ở Chế Độ Khẩn Cấp',
  'emergency.message': 'Thư viện âm thanh không khả dụng. Đang dùng cấu hình giới hạn.',
  'emergency.retry': 'Thử Lại',

  // Accessibility
  'a11y.numberCalled': 'Số {number} đã được gọi',
  'a11y.gameComplete': 'Trò chơi kết thúc. {count} số đã gọi. Thời gian: {time}.',
  'a11y.skipToContent': 'Chuyển đến nội dung chính',
  'a11y.gridLabel': 'Bảng số Lô Tô',
  'a11y.cellCalled': 'Số {number}, đã gọi',
  'a11y.cellNotCalled': 'Số {number}, chưa gọi',

  // Keyboard help
  'keyboard.title': 'Phím Tắt',
  'keyboard.next': 'Xướng số tiếp theo',
  'keyboard.autoplay': 'Bật/tắt tự động xướng',
  'keyboard.settings': 'Mở cài đặt',
  'keyboard.reset': 'Chơi ván mới',
  'keyboard.close': 'Đóng hộp thoại / Bỏ qua âm thanh',
  'keyboard.help': 'Hiện trợ giúp phím tắt',

  // Audio errors
  'error.consecutiveFailures': '⚠️ Lỗi Phát Âm Thanh\nNhiều tệp âm thanh không tải được.',
  'error.checkConnection': 'Kiểm Tra Kết Nối',
  'error.continueSilent': 'Tiếp Tục Không Âm Thanh',

  // Multi-tab
  'multitab.stateChanged': '⚠️ Trạng thái trò chơi đã được cập nhật ở tab khác.',
  'multitab.reload': 'Tải Lại Ngay',

  // Guideline
  'header.guideline': 'Hướng dẫn',
  'guideline.title': '📖 Hướng Dẫn',
  'guideline.aboutTitle': 'Giới Thiệu Lô Tô',
  'guideline.aboutContent': 'Lô Tô là một trò chơi truyền thống được yêu thích tại Việt Nam, tương tự như trò Bingo. Trò chơi bắt nguồn từ miền Nam Việt Nam và thường được chơi tại các lễ hội, hội chợ, sự kiện cộng đồng và gia đình. Người xướng số sẽ gọi các số từ 1 đến 99 (tuỳ nơi) — thường hát theo phong cách xướng đặc trưng, du dương — trong khi người chơi đánh dấu các số trùng khớp trên thẻ của mình. Trò chơi nổi tiếng với không khí sôi động, âm nhạc vui nhộn và tinh thần cộng đồng.',
  'guideline.howToWinTitle': 'Cách Thắng',
  'guideline.howToWinContent': 'Mỗi người chơi nhận một thẻ Lô Tô có chứa một số lượng số từ 1 đến 99 (tuỳ chổ). Khi người xướng gọi từng số, người chơi kiểm tra thẻ và đánh dấu các số trùng khớp. Người chơi đầu tiên hoàn thành một hàng, một cột, hoặc toàn bộ thẻ (tùy theo luật đã thống nhất) sẽ hô "Kinh!" và thắng vòng đó. Một số biến thể yêu cầu hoàn thành các hình mẫu cụ thể cho các mức giải thưởng khác nhau.',
  'guideline.howToUseTitle': 'Cách Sử Dụng Trang Web',
  'guideline.howToUseContent': 'Trang web này đóng vai trò là người xướng số Lô Tô kỹ thuật số. Cách sử dụng:\n\n• Nhấn "Bắt Đầu Thôi" hoặc phím N/Space để gọi số đầu tiên.\n• Các số được gọi lần lượt kèm theo âm thanh xướng số.\n• Sử dụng "Tự Động Xướng" hoặc phím A để tự động gọi số theo khoảng thời gian cài đặt.\n• Mở Cài Đặt (⚙️) để chọn ngôn ngữ âm thanh, phong cách xướng, phạm vi số và tốc độ tự động phát.\n• Bảng số sẽ tô sáng tất cả các số đã gọi để dễ theo dõi.\n• Nhấn "Chơi Ván Mới" hoặc phím R để bắt đầu trò chơi mới.\n• Nhấn phím ? để xem tất cả phím tắt.',
  'guideline.close': 'Đóng',

  // Donate
  'donate.button': 'Ủng hộ',
  'donate.title': '❤️ Ủng Hộ',
  'donate.thankYou': 'Cảm ơn bạn đã ủng hộ!\n\nTự hào văn hoá Việt Nam!',
  'donate.message': 'Nếu bạn thấy ứng dụng này hữu ích, bạn có thể ủng hộ chúng tôi bằng cách quét mã QR bên dưới. Mọi đóng góp đều giúp chúng tôi duy trì và phát triển ứng dụng.',
  'donate.scanQr': 'Quét mã QR để ủng hộ',
  'donate.close': 'Đóng',

  // Terms of Service
  'terms.link': 'Điều khoản sử dụng',
  'terms.title': 'Điều khoản sử dụng',
  'terms.section1Title': '1. Mục đích của website',
  'terms.section1Content': 'Website cung cấp công cụ hò lô tô trực tuyến nhằm phục vụ mục đích giải trí, sinh hoạt cộng đồng, hội nhóm và sự kiện.\nWebsite không phải là nền tảng tổ chức trò chơi cá cược hay đánh bạc.',
  'terms.section2Title': '2. Hành vi bị nghiêm cấm',
  'terms.section2Content': 'Người dùng không được sử dụng website cho các hành vi cá cược, đánh bạc, ăn thua bằng tiền hoặc tài sản dưới mọi hình thức.',
  'terms.section3Title': '3. Trách nhiệm của người dùng',
  'terms.section3Content': 'Người dùng tự chịu hoàn toàn trách nhiệm đối với hành vi sử dụng website của mình.',
  'terms.section4Title': '4. Miễn trừ trách nhiệm',
  'terms.section4Content': 'Chủ website chỉ cung cấp công cụ kỹ thuật trung lập và không tham gia, không kiểm soát, không hưởng lợi từ các hành vi trái pháp luật của người dùng.',
  'terms.section5Title': '5. Điều khoản chung',
  'terms.section5Content': 'Việc tiếp tục sử dụng website đồng nghĩa với việc người dùng đã đọc, hiểu và đồng ý với điều khoản sử dụng này.',
  'terms.close': 'Đóng',
};
